module.exports = __webpack_public_path__ + "img/4光纤与光缆.ee92a161.jpg";